module.exports = __webpack_public_path__ + "img/ball_7.f5eaadea.svg";